import React, {
    useState,
    useEffect,
    useRef
} from 'react';

import styled, {css} from "styled-components";
import * as dawaAutocomplete2 from 'dawa-autocomplete2';



const Wrapper = styled.div.attrs(props => ({
    width: props.width || "320px"
}))`
    display: flex;
    flex-flow: column nowrap;
    margin: 0 0 8px 0;
    min-width: ${props => props.width}; 

    ${props => props.theme.mediaQueries.medium}{
        margin: 0 0 16px 0;
    }
`

const Label = styled.label`
    margin-bottom: 0px;
    display: inline-block;
    max-width: 100%;
    font-weight: 400;
    background: white
`

const SvgContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 8px;
    padding: 16px;
    //height: 64px;
    height: 56px;
    border: 1px solid #ECECE7;

    ${props => props.active && css`
        padding: 8px 16px;
    `}

    ${props => props.boarder && css`
        border-color: ${props => props.theme.codanColors.color};
        border-width: 1px;
        border-style: solid;
        padding: 8px 16px;
    `}

    ${props => props.error && css`
        border-color: ${props => props.theme.codanColors.codanErrorRed};
        border-width: 1px;
        border-style: solid;
        padding: 8px 16px;
    `}

    :hover {
        transition: all 100ms ease-in-out;
        border-color: ${props => props.theme.codanColors.color};
        border-width: 1px;
        border-style: solid;
    }
`

const InputContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`

const InputLabel = styled.div`
    z-index: 1;
    transition: all 150ms ease;
    // left: 0;
    // bottom: 0;
    // right: 0;
    // top: 0; 
    position: absolute;
    line-height: 2rem;
    font-size: 1.33rem;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.8rem;
        line-height: 1.2;
    }

    ${props => props.active && css`
        line-height: 1.3rem;
        font-size: 0.9rem;
        position: static;
        opacity: 0.6;

        ${props => props.theme.mediaQueries.medium}{
            font-size: 0.55rem;
            line-height: 0.65rem;
        }
    `}
`

const Input = styled.input`
    font-family: inherit;
    transition-delay: 150ms;
    transition: opacity 150ms ease-in-out;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
    padding: 0;
    width: 100%;
    border-left-style: none;
    border-left-width: 0;
    border-bottom-style: none;
    border-bottom-width: 0;
    border-right-style: none;
    border-right-width: 0;
    border-top-style: none;
    border-top-width: 0;
    background-color: transparent;
    outline: 0;
    margin: 0;
    opacity: 0;
    

    ${props => props.active && css`
        opacity: 1;
        font-size: 1.3rem;
        line-height: 2rem;

        ${props => props.theme.mediaQueries.medium}{
            font-size: 0.8rem;
            line-height: 1.2rem;
        }
    `}  
`

const AutocompleteContainer = styled.div`
    position: relative;
    width: 100%;
    max-width: 30em;

    .dawa-autocomplete-suggestions {
        margin: 0.3em 0 0 0;
        padding: 0;
        text-align: left;
        background: #FFFFFF;
        position: absolute;
        left: -17px;
        right: 0;
        z-index: 9999;
        overflow-y: auto;
        box-sizing: border-box;
        max-height: 234px;
        width: 320px;
        border: 1px solid #FFB600;
        border-top: 1px solid #ECECE7;

        ${props => props.theme.mediaQueries.medium}{
            width: 540px;
            font-size: 0.8rem;
            line-height: 1.2rem;
        }
    }
     
    .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion {
        margin: 0;
        list-style: none;
        cursor: pointer;
        padding: 0.4em 0.6em;
        padding: 0.4em 16px;
        color: #333;
    }
          
    .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion.dawa-selected,
    .dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:hover {
        background-color: rgba(255, 165, 0, 0.5);
    }
`

const Error = styled.p`
    color: ${props => props.theme.codanColors.codanErrorRed};
    font-size: 0.9rem;
    margin: 0; 

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.55rem;
    }
`

const LabelledInputValidatedNyKredit = ({
    type,
    pattern,
    name,
    onChange,
    errors,
    values,
    isStrong,
    labelText,
    svg,
    optionalFunction,
    ...props
}) => {
    const [active, setActive] = useState(false);
    const [boarder, setBoarder] = useState(false);
    const [value, setValue] = useState(values[name]);
    const [address, setAddress] = useState({});

    const dawaAutocompleteInputRef = useRef();

    //load Danmarks Adressers WEB API
    useEffect(() => {
        dawaAutocomplete2.dawaAutocomplete(dawaAutocompleteInputRef.current, {
            select: function (selected) {
    
                setAddress(selected)
    
                //add custom event for onChange
                const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                nativeInputValueSetter.call(dawaAutocompleteInputRef.current, selected.tekst);
                const e = new CustomEvent('input', { bubbles: true });
                dawaAutocompleteInputRef.current.dispatchEvent(e);
    
                
            },
            adgangsadresserOnly: false
        });
    }, [])

    useEffect(() => {
        // POLYFILL FOR CUSTOM EVENT IN IE //
        (function () {

            if ( typeof window.CustomEvent === "function" ) return false;
          
            function CustomEvent ( event, params ) {
              params = params || { bubbles: false, cancelable: false, detail: null };
              var evt = document.createEvent( 'CustomEvent' );
              evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
              return evt;
             }
          
            window.CustomEvent = CustomEvent;
          })();
    },[])

    useEffect(() => {
        if (values[name]) {
            setActive(true)
        }
    },[active])

    useEffect(() => {
        const addAutoValueToInput = () => {
            if (!optionalFunction) {
                if (values[name]) {
                    setActive(true)
                }

                setValue(values[name])
            }

        }

        addAutoValueToInput();

    }, [values[name]])

    const handelFocus = () => {
        setActive(true);
        setBoarder(true);
    }

    const handelBlure = () => {
        setActive(false);
        setBoarder(false);
    }

    const isJson = (str) => {
        try {
            JSON.parse(str)
        } catch (e) {
            return false;
        }
        return true;
    }

    const getSelectedAddressValues = (address) => {
        const addressValues = {
            PostNumber: address.data.postnr, 
            StreetName: address.data.adresseringsvejnavn,
            HouseNumber: address.data.husnr.replace(/[a-zA-Z]/g, ''),
            HouseLetter: address.data.husnr.replace(/[0-9]/g, ''),
            Floor: address.data.etage && address.data.etage.length === 1 ? `0${address.data.etage}` : address.data.etage,
            SideDoor: resolveSideDoor(address.data.dør)
        };

        return addressValues
    }

    const resolveSideDoor = (value) => {
        if(value == null || isNaN(value)){
            return value;
        }

        if(value.length === 1){
            return `000${value}`
        }

        if(value.length === 2){
            return `00${value}`
        }

        if(value.length === 3){
            return `0${value}`
        }
    }

    const handelChange= (event) => {
        if (address && Object.keys(address).length !== 0 && address.constructor === Object) {
            const addressValues = getSelectedAddressValues(address)
            for(const prop in addressValues) {
                onChange({
                    target: {
                        name: prop,
                        value: addressValues[prop],
                        type: type
                    }
                })
            }
            onChange(event);
        } else {
           onChange(event);
        }


        if (optionalFunction) {
            setValue(optionalFunction(event.target.value))
        } else {
            setValue(event.target.value)
        }
    }

    return (
        <Wrapper {...props}>
            <Label>
                <SvgContainer active={active} boarder={boarder} error={errors[name]}>
                    {svg}

                    <InputContainer>
                        <InputLabel 
                            active={active}
                            {...props}
                        >
                            {labelText}
                        </InputLabel>
                        <AutocompleteContainer className="autocomplete-container">
                            <Input 
                                type={type} 
                                ref={dawaAutocompleteInputRef} 
                                onFocus={handelFocus}
                                onBlur={handelBlure}
                                pattern={pattern}
                                name={name}
                                onChange={handelChange}
                                value={value || ''}
                                active={active}
                            />
                        </AutocompleteContainer>
                    </InputContainer>
                </SvgContainer>
            </Label>
            {errors[name] && (
                <Error>{errors[name]}</Error>
            )}
        </Wrapper>

    )
}

export default LabelledInputValidatedNyKredit;